import {getDeliveryAndStatusInfo} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useDeliveryAndStatusInfo = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_DELIVERY_STATUS_INFO'], queryFn: getDeliveryAndStatusInfo}],
  })

  const {deliveryAndStatusInfoJsonSchema, deliveryAndStatusInfoUISchema} = results?.[0]?.data || {}

  return {
    deliveryAndStatusInfoJsonSchema,
    deliveryAndStatusInfoUISchema,
  }
}
